import { useEffect, useState } from 'react'
import { api } from '../data/api'

// Small, any-authenticated-role-readable subset of PlatformSettings —
// the per-feature credits-balance unlock prices for gated exam-creation
// features (MSQ, Short Answer, Bloom's Taxonomy — see
// createExamForm.resolveExamAccess), plus estimatedCostPerMB shown next to
// the PDF upload in the Create Exam form.
export function usePlatformPublicSettings() {
  const [settings, setSettings] = useState({ featureUnlockPrices: {}, estimatedCostPerMB: null })

  useEffect(() => {
    api.get('/api/platform-settings/public').then(setSettings).catch(() => {})
  }, [])

  return settings
}
